import React from 'react';

const BankIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg 
        width={props.width || 24} 
        height={props.height || 24} 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.06543 18.0772V9.38184H6.40823V18.0772H5.06543Z" fill={props.color || "#141414"} />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.05273 20.0312H20.9568V21.3356H3.05273V20.0312Z" fill={props.color || "#141414"} />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.94727 17.4248H20.0609V18.7291H3.94727V17.4248Z" fill={props.color || "#141414"} />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3301 18.0772V9.38184H12.6729V18.0772H11.3301Z" fill={props.color || "#141414"} />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5977 18.0792V9.38379H18.9405V18.0792H17.5977Z" fill={props.color || "#141414"} />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0032 4.09033L5.18107 8.72889H18.8252L12.0032 4.09033ZM11.5412 2.81237C11.8186 2.62375 12.1878 2.62374 12.4652 2.81237L20.9913 8.60949C21.6365 9.04827 21.3169 10.0332 20.5293 10.0332H3.47713C2.68939 10.0332 2.36977 9.04827 3.0151 8.60949L11.5412 2.81237Z" fill={props.color || "#141414"} />
    </svg>
);

export default BankIcon; 